import { Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import { BestillerPrivatForm } from "../forms";
import { FormPage } from "./FormPage";

export const BestillerPrivatPage = () => {
  const { t } = useTranslation();
  return (
    <FormPage>
      <Heading data-size="lg">{t("pages.bestiller.privat.tittel")}</Heading>
      <Paragraph data-size="lg" className="text-balder-text-subtle">
        {t("pages.bestiller.privat.beskrivelse")}
      </Paragraph>
      <Paragraph data-size="xs" className="text-balder-text-subtle mb-2">
        {t("pages.bestiller.felt-paakrevd")}
      </Paragraph>
      <BestillerPrivatForm />
    </FormPage>
  );
};
